var _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 65,
    viewBox: "0 0 66 65",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.7153 4.0874L56.3389 14.6107C57.4816 35.9483 52.2988 46.4185 33.7153 60.9132C29.3948 57.5457 25.7828 54.4134 22.7812 51.2902C34.4024 46.7865 39.8316 42.3752 45.291 34.6048C36.7569 41.0175 30.749 44.8665 19.4477 47.5096C17.2898 44.8168 15.5484 42.0642 14.1625 39.1109C29.6176 36.3311 38.8129 29.5134 43.1877 23.7811C42.7406 24.0392 42.2786 24.3096 41.8001 24.5897C35.7978 28.1028 27.1802 33.1467 12.4116 34.7215C11.5871 32.2502 10.9601 29.6167 10.5016 26.7547C21.0967 24.3302 26.612 21.9568 32.6644 17.7678C26.3031 20.5321 21.2273 22.143 10.0181 23.0898C9.74018 20.4653 9.57743 17.6529 9.51172 14.6107L33.7153 4.0874Z",
    fill: "url(#paint0_linear_9220_17915)",
    fillOpacity: 0.78
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9220_17915",
    x1: 56.8666,
    y1: 15.1369,
    x2: 0.566915,
    y2: 15.1369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#065DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E8345",
    stopOpacity: 0.33
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBLogo);
export default __webpack_public_path__ + "static/media/b-logo.5d62fb0c298adb5d3ced53bbb18541c4.svg";
export { ForwardRef as ReactComponent };